import * as z from 'zod';

import { fileQuerySchema } from '@/_schemas/file';
import { statusQuerySchema } from '@/_schemas/status-input';

export const competitorQueryLinkerSchema = z.object({
  id: z.number(),
  name: z.string().min(3),
  status: statusQuerySchema,
  logo: z.array(fileQuerySchema).nullish(),
});

export type CompetitorQueryLinkerSchema = z.infer<typeof competitorQueryLinkerSchema>;
